import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';
// import {checkboxClasses as muiCheckboxProps, CheckboxClasses as MuiCheckboxClasses} from '@mui/material/Checkbox';
// import { typedEntries } from '@netx/core-next/utils';

export const CHECKBOX_CLASS_NAME = 'Checkbox';
export const CHECKBOX_CLASS_SLOTS = [
	'root',
	'error',
	'formControlLabel',
	'checkbox',
] as const;

export type CheckboxClassSlot = (typeof CHECKBOX_CLASS_SLOTS)[number];

export interface CheckboxClasses {
	root: string;
	error: string;
	formControlLabel: string;
	indeterminateUnchecked: string;
	psuedoDisabled: string;
	checkbox: string;
}

export type CheckboxClassKey = keyof CheckboxClasses;

export const getCheckboxUtilityClass = (slot: string) =>
	generateUtilityClass(CHECKBOX_CLASS_NAME, slot);

export const checkboxClasses: CheckboxClasses = generateUtilityClasses(
	CHECKBOX_CLASS_NAME,
	[
		'root',
		'error',
		'formControlLabel',
		'indeterminateUnchecked',
		'psuedoDisabled',
		'checkbox',
	],
);

export default checkboxClasses;
